// eApp_VideoThumbnail.js
import React, { useState } from 'react';
import { Video, Trash2, Lock, Unlock, Star, ArrowRight } from 'lucide-react';
import EditableText from './eApp_EditableText';

const VideoThumbnail = ({
  video,
  category,
  categories,
  onClick,
  onEdit,
  onDelete,
  onToggleLock,
  onToggleNew,
  onMoveVideo,
  lockImageUrl,
}) => {


  return (
    <div
      className={`p-4 bg-white rounded-xl shadow-md cursor-pointer transition-all hover:shadow-lg hover:scale-105 relative group`}
      onClick={onClick}
    >
      <div className="aspect-video bg-[#F0EAE2] rounded-lg flex items-center justify-center mb-2 overflow-hidden relative">
        {video.thumbnail ? (
          <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover" />
        ) : (
          <Video className="text-white transform transition-transform hover:scale-110" size={48} />
        )}
        {video.locked && (
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src={lockImageUrl}
              alt="Locked"
              className="w-full h-full object-cover opacity-50"
            />
          </div>
        )}
      </div>
      <EditableText
        value={video.title}
        onChange={(newTitle) => {
          const updatedVideo = { ...video, title: newTitle };
          onEdit(updatedVideo);
        }}
      />
      {/* Action Icons */}
      <div className="absolute top-2 right-2 flex flex-col items-end space-y-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="bg-red-500 text-white p-1 rounded-full"
        >
          <Trash2 size={16} />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleLock();
          }}
          className="bg-blue-500 text-white p-1 rounded-full"
        >
          {video.locked ? <Unlock size={16} /> : <Lock size={16} />}
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleNew();
          }}
          className="bg-green-500 text-white p-1 rounded-full"
        >
          <Star size={16} />
        </button>

      </div>
      {video.isNew && (
        <div className="absolute top-0 right-0 bg-green-500 text-white px-2 py-1 rounded-bl-lg">
          Nouveau
        </div>
      )}
    </div>
  );
};

export default VideoThumbnail;
